import { Component as VueComponent, defineComponent, h } from 'vue';

import noop from 'lodash/noop';
// PRODUCT-26110 Phase 2B2: 'vue-router/types/router' is a vue-router-3-only subpath,
// not present in v4's `exports` map at all -- module-not-found, not just a type
// mismatch. `VueRouter` -> `Router`.
import type { Router } from 'vue-router';

import { useIdoStore } from '@/store/store';
import getTransitionRoute from '@/utils/getTransitionRoute';
import getTransitionState, { TransitionState } from '@/utils/getTransitionState';

export default function withExpectedTransitionState(transitionState: TransitionState, Component: VueComponent) {
    function redirect(actualTransitionState: TransitionState, router: Router) {
        if (actualTransitionState !== transitionState) {
            router.push(getTransitionRoute(actualTransitionState)).catch(noop);
        }
    }

    // PRODUCT-26110 Phase 2B2 Task 5 batch 4: see withErrorHandler.ts's identical note --
    // `Vue.component(name, ...)` used only as a definition-object builder, never
    // registered/looked-up by name; `defineComponent` is the direct Vue 3 replacement.
    return defineComponent({
        computed: {
            transitionState() {
                return getTransitionState(useIdoStore());
            },
        },

        watch: {
            // Watching the computed is what subscribes to the store: `render` reads nothing
            // from it, so it would otherwise never be evaluated.
            transitionState(actualTransitionState: TransitionState) {
                redirect(actualTransitionState, this.$router);
            },
        },

        created() {
            redirect(this.transitionState, this.$router);
        },

        render() {
            return h(Component);
        },
    });
}
